import React, { useEffect, useState } from "react";
import "./profile.scss";
import { Avatar, Button, Col, Divider, Input, Row, Typography } from "antd";
import { HandleErrors } from "../../../../utils/handleErrors";
import {
  getConfigMapByKeyService,
  updateConfigMapService,
} from "../../../../services/configmap.service";
import {
  ConfigMapKey,
  GetConfigMapRes,
} from "../../../../interfaces/configMap.interface";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { GetPermissionRes } from "../../../../interfaces/role.interface";
import { PermissionCode } from "../../../../enum/permission";
import { AddLogoModal } from "../../../../components/addLogoModal/addLogoModal";

const Profile = () => {
  const userPermissions = useSelector<RootState, GetPermissionRes[]>(
    (root) => root.user.permissions
  );
  const [loading, setLoading] = useState(false);

  const [addLogoShow, setAddLogoShow] = useState(false);

  const [nameConfig, setNameConfig] = useState<GetConfigMapRes>(
    {} as GetConfigMapRes
  );
  const [logoConfig, setLogoConfig] = useState<GetConfigMapRes>(
    {} as GetConfigMapRes
  );

  useEffect(() => {
    getOrganizationName();
    getOrganizationLogo();
  }, []);

  const getOrganizationName = async () => {
    try {
      const res = await getConfigMapByKeyService({
        key: ConfigMapKey.organizationName,
      });

      setNameConfig(res);
    } catch (error) {
      HandleErrors(error);
    }
  };

  const getOrganizationLogo = async () => {
    try {
      const res = await getConfigMapByKeyService({
        key: ConfigMapKey.organizationLogo,
      });

      setLogoConfig(res);
    } catch (error) {
      HandleErrors(error);
    }
  };

  const update = async () => {
    try {
      setLoading(true);

      if (!nameConfig.value) {
        toast.error("نام سازمان را وارد کنید");
        setLoading(false);
        return;
      }

      const res = await updateConfigMapService(nameConfig);

      setLoading(false);
      toast.success("اطلاعات با موفقیت ثبت شد");
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  return (
    <div className="OrganizationProfile">
      <Row align={"middle"} justify={"start"} className="title-box">
        <Col>
          <Typography.Text className="title">پروفایل سازمان</Typography.Text>
        </Col>
      </Row>
      <div className="info-box">
        <Row>
          <Col>
            <Typography.Text className="title">اطلاعات سازمان</Typography.Text>
          </Col>
        </Row>
        <Divider />
        <Row justify={"space-between"} align={"middle"}>
          <Col md={11} xs={24} className="logo-box">
            <div className="logo"><img className="img" src={`${(window as any).env.base_url}/${logoConfig.value}`} alt="" /></div>
            <Typography.Text
              className="title"
              onClick={() => {
                setAddLogoShow(true);
              }}
            >
              تغییر لوگو
            </Typography.Text>
          </Col>
          <Col md={11} xs={24} className="input-box">
            <Typography.Text className="title">
              <span style={{ color: "red" }}>*</span>نام سازمان:{" "}
            </Typography.Text>
            <Input
              className="input"
              value={nameConfig?.value}
              onChange={(e) => {
                setNameConfig({
                  ...nameConfig,
                  value: e.target.value,
                });
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={3} xs={24} className="btn-box">
            {userPermissions.find(
              (p) => p.code === PermissionCode.updateConfigMap
            ) && (
              <Button
                loading={loading}
                onClick={update}
                className="btn"
                type="primary"
                block
              >
                ذخیره
              </Button>
            )}
          </Col>
        </Row>
      </div>
      <AddLogoModal
        show={addLogoShow}
        onClose={() => {
          setAddLogoShow(false);
          getOrganizationLogo();
        }}
      />
    </div>
  );
};

export default Profile;
